if (typeof(Adcurve) === "undefined") {
  window.Adcurve = {};
}

import CustomFlowSuccessHandler from "./CustomFlowSuccessHandler";
import "./Integration";
import "./PasswordForm";

export default { CustomFlowSuccessHandler };
